export default "__VITE_ASSET__DsyLzHQr__"